import { Component, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Router, ActivatedRoute } from '@angular/router';
import { TransactionService } from '../shared/';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { BreadCrumbModel, StepIndicatorService } from 'lib/ng2-sapmp/src/ui-components';
import { DatePipe } from '@angular/common';
import { ReportService } from './../../shared/';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';

@Component({
  selector: 'app-transaction-review',
  providers: [TransactionService, ReportService],
  templateUrl: './transaction-review.component.html',
  styleUrls: ['./transaction-review.component.scss']
})
export class TransactionReviewComponent implements OnInit {
  singleDevice: boolean;
  showError: boolean;
  showReportSelection: boolean;
  public startDate: string;
  public endDate: string;
  fan: string;
  public selectedCtn: string;
  public format: string;
  public dateRange: any;
  public accountType: string;

  constructor(private parentRouter: Router,
    private transactionService: TransactionService,
    private utilityService: UtilityService,
    private stepIndicator: StepIndicatorService,
    private router: Router,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private reportService: ReportService,
    private pageloaderService: PageLoaderService
  ) { }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    const reportRequest = this.transactionService.getReportModel();
    this.singleDevice = reportRequest.accountType === 'singleDevice';
    this.showError = false;
    this.showReportSelection = false;
    this.stepIndicator.setCurrentStep(this.route.snapshot.url[0].path);
    this.stepIndicator.setVisibility(true);


    this.fan = reportRequest.selectedFan ? reportRequest.selectedFan.name : '';
    this.selectedCtn = reportRequest.selectedCtn.ctn ? reportRequest.selectedCtn.ctn.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1.$2.$3') : '';
    this.startDate = this.datePipe.transform(reportRequest.startDate, 'MM/dd/yyyy');
    this.endDate = this.datePipe.transform(reportRequest.endDate, 'MM/dd/yyyy');
    this.format = this.reportService.getReportObject().format;
    this.dateRange = reportRequest.dateRange.name;
    this.accountType = reportRequest.accountType;
    this.transactionService.createPageLoadProperties('REVIEW', 'review');

  }

  doRequestReport() {
    const reportRequest = this.transactionService.getReportModel();
    reportRequest.format = this.format;
    this.transactionService.setReportModel(reportRequest);
    let url = this.utilityService.getEnvConfig().getTransactionReportRequestUrl;
    const startDate = this.datePipe.transform(reportRequest.startDate, 'MM/dd/yyyy');
    const endDate = this.datePipe.transform(reportRequest.endDate, 'MM/dd/yyyy');
    const userInfo = sessionStorage.getItem('user');
    const user = JSON.parse(userInfo);
    const userEmail = user.user.emailAddress;
    const userName =  user.user.firstName + ' ' + user.user.lastName;
    const format = this.format === 'PDF' ? 'PDF' : 'XLS';

    if (this.accountType === 'allFan') {
      url = url + 'all';
    } else if (this.accountType === 'singleDevice') {
      url = url + 'device/' + reportRequest.selectedCtn.ctn;
    } else {
      url = url + 'fan/' + reportRequest.selectedFan.name;
    }
    url = url + '?startdate=' + startDate +
      '&enddate=' + endDate + '&type=' + format + '&email=' + userEmail + '&username=' + userName;
      const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
      const isDisabled = impersonator && impersonator.id ? true : false;
      if (isDisabled) {
        (<HTMLInputElement>document.getElementById('transaction-review-btn')).disabled = true;
      } else {
        this.pageloaderService.setPageLoaderStatus(false);
        if (this.utilityService.getEnvConfig().useMock){
          url = this.utilityService.getEnvConfig().getTransactionReportRequestUrl;
        }      
        this.transactionService.doRequestReport(url)
          .subscribe(respobj => {
            this.pageloaderService.setPageLoaderStatus(true);
            if (respobj.message === 'True') {
              this.parentRouter.navigateByUrl('/reports/transaction/confirmation');
            }else {
              this.showError = true;
            }
          }, error => {
            this.pageloaderService.setPageLoaderStatus(true);
            this.handleError(error);
          });
      }
  }
  handleError(error) {
    // console.log('error');
    // throw error;
    this.showError = true;
  }

  backToPrevious(event) {
    event.preventDefault();
    this.router.navigate(['/reports/transaction/dateRange']);
  }

  selectReportFormat() {
    this.showReportSelection = true;
  }
}
